export default "__VITE_ASSET__9fb25b91__"